import React, { useEffect, useState } from 'react';
import { string, arrayOf, number, object } from 'prop-types';
import useInterval from '../../../hooks/useInterval';
import styles from './styles/styles.module.scss';

// TODO: Let's move this to the new @alltrails/utils package once that is fully integrated
const preFetchImages = imageUrls => {
  const promises = imageUrls.map(imageUrl => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageUrl;
      image.onload = resolve;
      image.onerror = reject;
    });
  });

  return Promise.all(promises);
};

const RotatingHero = ({ imageUrls, className, duration, buttonContainerStyle, children }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const [delay, setDelay] = useState(duration);
  const style = { backgroundImage: `url(${imageUrls[currentImageIndex]})` };

  const handleSlideClick = index => {
    // pause or restart image rotation
    setCurrentImageIndex(index);
    setPaused(!paused);
    setDelay(paused ? duration : null);
  };

  const renderSlideButtons = () => (
    <div className={styles.slideButtons} style={buttonContainerStyle}>
      {imageUrls.map((url, index) => {
        const progressSpanStyle = {};
        const innerSpanClassNames = [];

        if (index < currentImageIndex) {
          innerSpanClassNames.push(styles.slideButtonSpanComplete);
        } else if (index === currentImageIndex) {
          innerSpanClassNames.push(styles.slideButtonSpanActive);
          progressSpanStyle.animationDuration = `${duration}ms`;
          progressSpanStyle.animationPlayState = `${paused ? 'paused' : 'running'}`;
        }

        return (
          <button key={url} type="button" className={styles.slideButton} onClick={() => handleSlideClick(index)}>
            <span className={styles.slideButtonSpan}>
              <span className={innerSpanClassNames.join(' ')} style={progressSpanStyle} />
            </span>
          </button>
        );
      })}
    </div>
  );

  useEffect(() => {
    preFetchImages(imageUrls).catch(error => console.error('Error preFetching RotatingHero images', error));
  }, []);

  useInterval(() => {
    let nextIndex = currentImageIndex + 1;

    if (nextIndex === imageUrls.length) {
      nextIndex = 0;
    }

    setCurrentImageIndex(nextIndex);
    setDelay(duration);
  }, delay);

  return (
    <div className={`${className} ${styles.container}`} style={style}>
      {children}
      {renderSlideButtons()}
    </div>
  );
};

RotatingHero.propTypes = {
  imageUrls: arrayOf(string).isRequired,
  className: string.isRequired,
  duration: number,
  buttonContainerStyle: object
};

RotatingHero.defaultProps = {
  duration: 4000,
  buttonContainerStyle: {}
};

export default RotatingHero;
